import React from 'react';
import { Table } from 'semantic-ui-react';
import { FormattedMessage } from 'react-intl';
import ValidationError from '@/containers/ValidationError';

const UnsortedColumn = ({
  colSpan,
  colWidth,
  error,
  columnId,
  columnText,
  textAlign,
}) => (
  <Table.HeaderCell
    singleLine
    colSpan={colSpan}
    width={colWidth}
    textAlign={textAlign}
    className="z-5"
  >
    {columnId && (
      <ValidationError error={error} position="bottom right">
        <FormattedMessage className="table-column-header" id={`table.header.${columnId}`} />
      </ValidationError>
    )}
    {columnText}
  </Table.HeaderCell>
);

export default UnsortedColumn;
